import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Districts {
  name: string;
  api_token: string;
}

export interface DistrictsListInfor {
  errors: unknown;
  districts: Districts;
  isAuthenticated: boolean;
}

@Module
export default class DistrictsModule
  extends VuexModule
  implements DistrictsListInfor
{
  errors = {};
  districts = {} as Districts;
  isAuthenticated = !!JwtService.getToken();

  get Districts() {
    return this.districtsListData;
  }

  @Mutation
  [Mutations.DISTRICTS_LIST_DATA](Districts) {
    this.districtsListData = Districts;
  }

  @Action
  [Actions.DISTRICTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("districts", payload)
        .then((response) => {
          this.context.commit(Mutations.DISTRICTS_LIST_DATA, response.data);
          return response.data;
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
          return Promise.reject(response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
